import { render, staticRenderFns } from "./SalaryAdvanceAddEditModal.vue?vue&type=template&id=54f752a5"
import script from "./SalaryAdvanceAddEditModal.vue?vue&type=script&lang=js"
export * from "./SalaryAdvanceAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports